<template>
  <div ref="el">
    <div class="main-question">
      <contenteditable
        tag="p"
        :contenteditable="true"
        v-model="question"
        :noNL="true"
        @input="updateQuestion"
      />
    </div>
    <div class="node-custom-outputs">
      <div class="custom-output" v-for="(output, index) in outputs" :key="output.id">
        <button
          type="button"
          class="decision-remove-output"
          :title="$t('action_plan.nodes.decision.config.remove_output')"
          :aria-label="$t('action_plan.nodes.decision.config.remove_output')"
          @mousedown.stop
          @click.stop="removeOutput(output.id)"
        >
          <feather-icon icon="XCircleIcon" size="16" />
        </button>
        <contenteditable
          tag="p"
          :contenteditable="true"
          v-model="output.text"
          :noNL="true"
          @input="updateOutput($event, index)"
        />
      </div>
    </div>
    <div class="decision-output-actions">
      <button
        type="button"
        class="decision-add-output"
        :disabled="!canAddOutput"
        :title="$t('action_plan.nodes.decision.config.add_output')"
        :aria-label="$t('action_plan.nodes.decision.config.add_output')"
        @mousedown.stop
        @click.stop="addOutput"
      >
        <feather-icon icon="PlusCircleIcon" size="18" />
      </button>
      <span class="decision-output-count" aria-live="polite">
        {{ outputsLength }}/{{ maxOutputs }}
      </span>
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import contenteditable from "@/components/Contenteditable";
import {
  ACTION_PLAN_MAX_DECISION_OUTPUTS,
  canAddActionPlanDecisionOutput,
} from "@/config/flowchart";

export default {
  mixins: [nodeMixin],
  components: {
    contenteditable,
  },
  data() {
    return {
      question: this.$t("action_plan.nodes.decision.config.question"),
      minOutputs: 2,
      maxOutputs: ACTION_PLAN_MAX_DECISION_OUTPUTS,
      outputs: [
        {
          id: "output_1",
          text: this.$t("action_plan.nodes.decision.config.yes"),
        },
        {
          id: "output_2",
          text: this.$t("action_plan.nodes.decision.config.no"),
        },
      ],
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    if (this.nodeData.data.config) {
      if (this.nodeData.data.config.question) {
        this.question = this.nodeData.data.config.question;
      }

      if (this.nodeData.data.config.custom_outputs) {
        this.outputs = this.nodeData.data.config.custom_outputs;
      }
    } else {
      this.nodeData.data.config = {};
      this.question = this.nodeData.data.config.question = this.$t(
        "action_plan.nodes.decision.config.question"
      );
      this.updateNodeConfig();
    }
  },
  computed: {
    outputsLength() {
      return this.outputs.length;
    },
    canAddOutput() {
      return canAddActionPlanDecisionOutput(this.outputsLength);
    },
  },
  methods: {
    addOutput() {
      if (!this.canAddOutput) return;
      this.$df.addNodeOutput(this.nodeId);
      this.outputs.push({
        id: `output_${this.outputsLength + 1}`,
        text: this.$t("action_plan.nodes.decision.config.new_output"),
      });
      this.updateNodeConfig();
    },
    removeOutput(output) {
      if (this.outputsLength === 1) return;
      this.$df.removeNodeOutput(this.nodeId, output);
      this.outputs = this.outputs.filter((o) => o.id !== output);
      this.outputs.forEach((o, index) => {
        this.outputs[index].id = `output_${index + 1}`;
      });
      this.updateNodeConfig();
    },
    updateQuestion(value) {
      this.question = value;
      this.updateNodeConfig();
    },
    updateOutput(value, index) {
      this.outputs[index].text = value;
      this.updateNodeConfig();
    },
    updateNodeConfig() {
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      this.updateNodeData({
        config: {
          ...(currentNode.data.config || {}),
          question: this.question,
          custom_outputs: this.outputs,
        },
      });
    },
  },
};
</script>

<style></style>
